import {
  ANNOUNCEMENT_RESOURCE,
  WHATS_NEW_RESOURCE,
  SUPPORT_TICKET,
  READ_ACTION,
  MANAGE_ACTION,
  NOTIFICATIONS_RESOURCE_MENU,
  CONTRACT_DELETE_RESOURCE_MENU
} from "@/constants/resources";

export default [
  {
    title: "Notificações",
    icon: "none",
    children: [
      {
        title: "Notificações recebidas",
        route: "notification-inbox-unread",
        icon: "BellIcon",
        resource: NOTIFICATIONS_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Gestão de chamados",
        route: "support-tickets",
        icon: "MessageSquareIcon",
        resource: SUPPORT_TICKET,
        action: READ_ACTION,
      },
      {
        title: "Comunicados",
        route: "announcements-list",
        icon: "SendIcon",
        resource: ANNOUNCEMENT_RESOURCE,
        action: MANAGE_ACTION,
      },
      {
        title: "O que há de novo",
        route: "whats-new-list",
        icon: "GiftIcon",
        resource: WHATS_NEW_RESOURCE,
        action: MANAGE_ACTION,
      },
      {
        title: "Exclusão de contrato",
        route: "deletion-request-list",
        icon: "XCircleIcon",
        resource: CONTRACT_DELETE_RESOURCE_MENU,
        action: READ_ACTION,
      },
    ],
  },
];
